"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UnpinIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(UnpinIcon, _React$PureComponent);

  function UnpinIcon() {
    _classCallCheck(this, UnpinIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(UnpinIcon).apply(this, arguments));
  }

  _createClass(UnpinIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'unpin-icon')
      }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
        fill: color,
        d: "M8.77955,8.0714 L10.66155,6.1894 C11.10755,5.7434 11.00155,4.9854 10.44755,4.6854 C9.57755,4.2144 8.58055,4.0884 7.62955,4.2694 L9.95055,1.9494 C10.14555,1.7544 10.14555,1.4384 9.95055,1.2424 C9.75455,1.0474 9.43855,1.0474 9.24355,1.2424 L6.83255,3.6534 L3.65355,6.8324 L1.24355,9.2424 C1.04755,9.4384 1.04755,9.7544 1.24355,9.9494 C1.34055,10.0474 1.46855,10.0964 1.59655,10.0964 C1.72455,10.0964 1.85255,10.0474 1.95055,9.9494 L4.26955,7.6304 C4.08755,8.5804 4.21455,9.5774 4.68555,10.4474 C4.98555,11.0014 5.74355,11.1074 6.18955,10.6614 L8.07255,8.7784 L11.14655,11.8534 C11.24455,11.9514 11.37255,12.0004 11.49955,12.0004 C11.62755,12.0004 11.75555,11.9514 11.85355,11.8534 C12.04855,11.6584 12.04855,11.3414 11.85355,11.1464 L8.77955,8.0714 Z"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M2.99025,6.0815 L6.08125,2.9905 L4.53525,1.7065 C4.92625,1.3165 4.92625,0.6835 4.53525,0.2925 C4.14525,-0.0975 3.51125,-0.0975 3.12125,0.2925 L0.29325,3.1215 C-0.09775,3.5115 -0.09775,4.1445 0.29325,4.5355 C0.68325,4.9265 1.31625,4.9265 1.70725,4.5355 L2.99025,6.0815 Z"
      })));
      /* eslint-enable max-len */
    }
  }]);

  return UnpinIcon;
}(_react.default.PureComponent);

exports.default = UnpinIcon;
UnpinIcon.defaultProps = {
  color: 'inherit'
};
UnpinIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};